import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { SettingsRoute } from "./setting.routes";

export function Setting() {
  return (
    <Layout>
      {SettingsRoute.subRoutes && (
        <ModuleRouter subRoutes={SettingsRoute.subRoutes} path={SettingsRoute.path} />
      )}
    </Layout>
  );
}
